import { call, put, select, takeEvery } from "redux-saga/effects";
import { LOAD_PROFILE_ACTION, UPDATE_STRIPE_CUSTOMER_ACTION } from "./actionTypes";
import { PayloadAction } from "@reduxjs/toolkit";
import { initUserProfile } from "../../service/profile";
import { UserAuthInfo } from "../../types/auth";
import { loadPaymentMethod, loadProfileError, loadProfileSuccess, updateStripeCustomerError, updateStripeCustomerSuccess } from "./slice";
import { StoreState } from "../reducer-main";
import { StripeCustomerBillingData } from "../../types/stripe";
import {  getFirstPaymentMehod, updateStripeCustomerBillingData } from "../../service/common/stripe";
import { ProfileInitResponse, TrialMembership, UserProfile } from "../../types/profile";
import { ProcessingPayment, retrieveAlreadyExistingProcessingPayment } from '../../service/processingPayments';
import { updateProcessingPaymentState } from '../processingPayment/slice';
import { callCloudFunction, firestoreDocUpdate } from '../../service/common/firebase';
import { USER_DB_REF } from '../../constants/firestore';
import { toast } from 'react-toastify';
import { CONSUME_PROMO_CODE_CLOUD_FUNCTION, DELETE_USER_CLOUD_FUNCTION } from '../../constants/cloudFunctions';
import { IConsumePromoCodeCloudFunctionPayload } from '../../types/cloudFunctions';

// TODO: Tipizzare generatore
// TODO: Controllo su promo, per non richiedere all'utente il pagamento immadiato
// TODO: Aggiungere controllo su esistenza di un intent creato precedentemente
function* loadProfile({
  payload: userAuthInfo
}: PayloadAction<UserAuthInfo | null>): any {
  try {
    const displayName: string = yield select((state: StoreState) => state.profile.displayName);
    const userProfileResponse: ProfileInitResponse | null = userAuthInfo 
      ? yield call(initUserProfile, userAuthInfo, displayName) 
      : null;
    console.log('💚INIT PROFILE💚', userProfileResponse);
    if (userProfileResponse) {
      const { userProfile, isRegistration } = userProfileResponse;
      const promoCode: string = yield select((state: StoreState) => state.profile.promoCode);
      if (isRegistration && promoCode.length > 0) {
        const cfPayload: IConsumePromoCodeCloudFunctionPayload = { code: promoCode };
        const consumePromoCodeCfResponse =  yield call(callCloudFunction, CONSUME_PROMO_CODE_CLOUD_FUNCTION, cfPayload);
        console.log({consumePromoCodeCfResponse});
        if (consumePromoCodeCfResponse.data.outcome) {
          const trialMembership: TrialMembership = consumePromoCodeCfResponse.data.data;
          console.log({...userProfile, membership: trialMembership});
          yield put(loadProfileSuccess({...userProfile, membership: trialMembership}));
        } else throw consumePromoCodeCfResponse.data.error;
      } else {
        // Controllo su pagamenti da finalizzare
        const alreadyExistingProcessingPayment: ProcessingPayment = yield call(retrieveAlreadyExistingProcessingPayment, userProfile.uid);
        if (alreadyExistingProcessingPayment) {
          yield put(updateProcessingPaymentState(alreadyExistingProcessingPayment.state));
        }
        const payementMethod =  yield call(getFirstPaymentMehod,userProfile.stripeCustomer.id);
        yield put(loadPaymentMethod(payementMethod));
        yield put(loadProfileSuccess(userProfile));
      }
    } else {
      yield put(loadProfileSuccess(null));
      yield put(loadPaymentMethod(null));
    }
  } catch (error: any) {
    console.log('err', error);
    if (error?.code && error?.description) {
      toast.error(error.description);
      yield put(loadProfileError(error.description));
      yield call(callCloudFunction, DELETE_USER_CLOUD_FUNCTION, null);
    } else {
      toast.error('Si è verificato un errore');
      yield put(loadProfileError(error));
    }
    yield put(loadProfileSuccess(null));
    yield put(loadPaymentMethod(null));
  }
}

function* updateStripeCustomer({
  payload: customerBillingData
}: PayloadAction<StripeCustomerBillingData>): any {
  try {
    const userProfile: UserProfile | null = yield select((state: StoreState) => state.profile.userProfile);
    if (userProfile) {
      const { stripeCustomer } = userProfile;
      const newStripeCustomer = yield call(updateStripeCustomerBillingData, stripeCustomer.id, customerBillingData);
      const updatePayload = { stripeCustomer: newStripeCustomer };
      yield call(firestoreDocUpdate, USER_DB_REF, userProfile.uid, updatePayload);
      yield put(updateStripeCustomerSuccess(newStripeCustomer));
    } else {
      yield put(updateStripeCustomerError(null));
    }
  } catch (error) {
    console.log('ERR SAGA UPDATE STRIPE CUSTOMER', error);
  }
}

export default function* profileSaga() {
  yield takeEvery(LOAD_PROFILE_ACTION, loadProfile);
  yield takeEvery(UPDATE_STRIPE_CUSTOMER_ACTION, updateStripeCustomer);
}